import * as backend from '@/lib/backend';
import { trackError } from '@/lib/error_tracker';
import { trackEvent } from '@/lib/event_tracker';

import * as Session from '@/lib/data/session';
import * as User from '@/lib/data/user';

export default async function authenticateThenRedirect(
  session,
  pathname,
  dispatch,
  router,
  { freePlanSubscriberPath, paidPlanSubscriberPath }
) {
  if (Session.isAuthenticated(session)) {
    if (
      paidPlanSubscriberPath &&
      User.isPaidPlanSubscriber(session.get('user'))
    ) {
      router.push(paidPlanSubscriberPath);
      return;
    }

    if (
      freePlanSubscriberPath &&
      User.isFreePlanSubscriber(session.get('user'))
    ) {
      router.push(freePlanSubscriberPath);
      return;
    }
  }

  trackEvent(session, pathname, 'Authentication Attempted', {});

  const { exception, error, response, data } = await backend.signIn(session, {
    queryParams: {
      redirectBaseUrl: window.location.origin,
      currentPath: window.location.pathname,
      freePlanSubscriberPath: encodeURIComponent(freePlanSubscriberPath),
      paidPlanSubscriberPath: encodeURIComponent(paidPlanSubscriberPath),
    },
  });

  if (error || exception) {
    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: `Problems authenticating: ${error || exception}`,
      },
    });

    trackError(
      session,
      'Authentication Failed',
      exception,
      response
        ? {
            responseStatus: response?.status,
          }
        : {}
    );

    return;
  }

  if (!data.authorizeUrl) {
    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: "Problems authenticating: couldn't get authorize URL",
      },
    });

    trackError(session, 'Authentication Failed', null, {
      authorizeUrlError: true,
    });

    return;
  }

  window.location.assign(data.authorizeUrl);
}
